import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-ty-page',
  imports: [NzIconModule, TranslateModule],
  templateUrl: './ty-page.component.html',
  styleUrl: './ty-page.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TyPageComponent implements OnInit {
  isFromPayment?: string;
  @Input() selectedRoute?: string | null | undefined;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const paymentResult = this.route.snapshot.queryParamMap.get('MESSAGGIO_1');
    if (paymentResult && paymentResult === 'Success') {
      this.isFromPayment = paymentResult;
    }
  }

  protected exit(): void {
    localStorage.removeItem('price');
    localStorage.removeItem('consultType');
    this.router.navigate(['medical-consultations']).then();
  }
}
